import { request } from "../../api/api";

export const getSFGStoreData = (searchParams) => {
  const queryParams = Object.entries({
    class_id__class_name: searchParams.search.class_id__class_name,
    size__size_name: searchParams.search.size__size_name,
    length__length: searchParams.search.length__length,
    scre_type: searchParams.search.scre_type,
    quantity: searchParams.search.quantity,
    page: searchParams.page + 1,
    page_size: searchParams.rowsPerPage,
  })
    .filter(([, value]) => value !== undefined && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return request.get(`/sfg_store/getSFGStoreData/?${queryParams}`);
};

export const getSFGStoreDetails = (searchParams) => {
  const queryParams = Object.entries({
    created_at: searchParams.search.Date,
    batch__batch_type: searchParams.search.batch__batch_type,
    aging: searchParams.search.aging,
    box_no__box_no: searchParams.search.box_no,
    box_no__class_id__class_name: searchParams.search.class_id__class_name,
    box_no__lot_no__icontains: searchParams.search.lot_no,
    box_no__size__size_name__icontains: searchParams.search.size__size_name,
    box_no__length__length__icontains: searchParams.search.length__length,
    box_no__gloves_type__pairing_gloves_type_name__icontains: searchParams.search.scre_type,
    quantity__icontains: searchParams.search.quantity,
    box_no__scre_type__cuff_name: searchParams.search.cuff,
    box_no__no_of_prints: searchParams.search.prints,
    page: searchParams.page + 1,
    page_size: searchParams.rowsPerPage,
    start_datetime: searchParams.start_datetime,
    end_datetime: searchParams.end_datetime,
    created_by__username__icontains: searchParams.search.packed_by,
    box_no__sfg_label__icontains: searchParams.search.label_no,
  })
    .filter(([, value]) => value !== undefined && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return request.get(`/sfg_store/getSFGBoxHistoryDetails/?${queryParams}`);
};

export const getSFGBoxNo = () => {
  return request.get("/sfg_store/getSFGBoxNo/");
};

export const getSFGBoxStorageData = (id) => {
  return request.get(`/sfg_store/getSFGBoxStorageData/?sfg_box_no=${id}`);
};

export const getSFGBoxRetrivalHistoryID = (id) => {
  return request.get(`/sfg_store/getSFGBoxRetrivalHistory?sfg_box_id=${id}`);
};
export const getSFGBoxData = (id) => {
  return request.get(`/sfg_store/getSFGBoxData/?sfg_box_no=${id}`);
};
export const submitRackId = (data) => {
  return request.post(`/sfg_store/submitRackID/`, data);
};
export const getSFGInventoryDetails = (searchParams) => {
  const queryParams = Object.entries(searchParams)
    .filter(([, value]) => value !== undefined && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return request.get(`/sfg_store/getSFGInventoryDetails/?${queryParams}`);
};
export const getSFGBagDetails = (params) => {
  return request.post("/sfg_store/getSFGBagDetail/", params);
};
export const getSFGClassSizeSummary = (params) => {
  return request.get("/sfg_store/getSFGClassSizeSummary/", { params });
};
export const getSFGBoxRetrivalHistory = (params) => {
  return request.get("/sfg_store/getSFGBoxRetrivalHistory/", params);
};
export const retriveSFGBoxGloves = (params) => {
  return request.post("/sfg_store/retriveSFGBoxGloves/", params);
};
export const createSFGBoxAndHistory = (params) => {
  return request.post("/sfg_store/createSFGBoxAndHistory/", params);
};

export const printAgainSFGBoxLabel = (params) => {
  return request.post("/sfg_store/printAgainSFGBoxLabel/", params);
};